const Dashboard = () => null;

export default Dashboard;
